<script>
    import TaxEstimator from './TaxEstimator.svelte';
    import { assessedValue } from './stores.js';
    import { unformat } from 'accounting';

	const rates_tax_year = Tax_Year;
    let rates = {
        "Residential": ResidentialTaxRates,
        "Business": BusinessTaxRates
    }

    const unformatInput = (e) => {
        $assessedValue = unformat(e.target.value)
    }

</script>
<section>
    <label for="assessed-value">Assessed Value</label>
    <input id="assessed-value" type="text" on:input="{unformatInput}" placeholder="0.00">
</section>
<section>
    <TaxEstimator rates="{rates}" tax_year="{rates_tax_year}"></TaxEstimator>
</section>
<style>
    section {
        margin: 1em 0;
    }
</style>